import { Button, DatePicker, Form, Row, Space } from 'antd';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { getGeneralInventory } from '../../../../appRedux/actions/Reports';
import { buttonLabel, formConfig } from '../../../../constants';

export const GeneralInventoryFilter = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onSubmit = (values) => {
    if (values?.dates) values.dates = moment(values?.dates).format('YYYY-MM');
    dispatch(getGeneralInventory(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="dates">
            <DatePicker picker="month" format={'YYYY-MM'} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
